export default __webpack_public_path__ + "static/1039-2ed3a85afaed4cfe994d7b9493112597.gif";